import { AuthenticationService } from 'src/services/authentication-service';
import { AuthToken, FetchTokenArgs } from 'src/state/auth/types';
import { createAppAsyncThunk } from 'src/state/thunk-api';

export const fetchTokenActionCreator = createAppAsyncThunk<AuthToken, FetchTokenArgs>(
  'auth/fetchToken',
  async ({ state, code }, { getState }) => {
    const {
      auth: { authenticationKey, codeVerifier },
    } = getState();

    if (!code || !state) {
      throw new Error('State or code parameter is missing');
    }

    if (authenticationKey !== state) {
      throw new Error('Authentication key and state do not match');
    }

    if (!codeVerifier) {
      throw new Error('Invalid state. No verifier found for challenge');
    }

    return AuthenticationService.fetchToken(code, codeVerifier);
  },
);
